export default {
  handleApiSuccess (store, success) {
    try {
      store.commit('setSuccess', {
        text: success,
        show: true
      })
      console.log('response: ' + JSON.stringify(success))
    } catch (ex) {
      console.log(JSON.stringify(ex))
    }
  }

}



// WEBPACK FOOTER //
// ./src/store/SuccessHandler.js